import { ApiClient } from "./api-client";

export function getPasswordReset(PasswordResetId) {
  return ApiClient.getInstance().get('/user/password/:id', { urlParams: { id: PasswordResetId } }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function createPasswordReset(email, handleError = true) {
  return ApiClient.getInstance().post('/user/password/request', { email: email }, undefined, handleError).catch((error) => {
    console.error('Error requesting a password reset:', error);
    throw error;
  });
}

export function confirmPasswordReset(PasswordResetId, password) {
  return ApiClient.getInstance().post('/user/password/confirm', { uuid: PasswordResetId, password: password }).catch((error) => {
    console.error('Error confirming new password:', error);
    throw error;
  });
}